import { NewAlert, RoleName } from "@/types";
import { createContext } from "react";

// Context Type
export type AppContextType = {
  alertData: NewAlert[];
  newAlerts: NewAlert[];
  isNavbarAlertsOpen: boolean;
  setIsNavbarAlertsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  userRole: RoleName;
  userDismissedUpdateAccount: boolean;
  setUserDismissedUpdateAccount: React.Dispatch<React.SetStateAction<boolean>>;
  userShouldUpdateAccount: boolean;
  setUserShouldUpdateAccount: React.Dispatch<React.SetStateAction<boolean>>;
  userShouldRegisterAccount: boolean;
};

// Default State for the context
export const defaultState: AppContextType = {
  alertData: [],
  newAlerts: [],
  isNavbarAlertsOpen: false,
  setIsNavbarAlertsOpen: () => {},
  userRole: "blocked_user",
  userDismissedUpdateAccount: true,
  setUserDismissedUpdateAccount: () => {},
  userShouldUpdateAccount: false,
  setUserShouldUpdateAccount: () => {},
  userShouldRegisterAccount: true,
};

export const AppContext = createContext<AppContextType>(defaultState);
